<template>
  <a-drawer
    v-model:visible="open"
    class="custom-class"
    root-class-name="root-class-name"
    :root-style="{ color: 'blue' }"
    :title="`绑定${title}详情`"
    :maskClosable="false"
    width="332"
    placement="right"
  >
    <div v-if="bindType === 'doctor'">
      <div class="doctorHeader">
        <auth-img class="avator" :src="bindInfo.headUrl || head_d" />
        <div class="intro">
          <div class="name">{{ bindInfo.name }}</div>
          <div>医生ID：{{ bindInfo.doctorId }}</div>
          <div>使用权限：{{ ['正常', '停用', '注销', '停用 | 注销'][bindInfo.accountStatus] }}</div>
        </div>
      </div>
      <a-divider style="margin: 16px 0" />
      <div class="doctorInfo">
        <div v-for="item in doctorConfig" :key="item.label" class="infoItem">
          <div class="label">{{ item.label }}</div>
          <div class="value" v-if="item.value === 'title'">
            {{ bindInfo.department }}
            <span v-if="bindInfo.title">|</span>
            {{ bindInfo.title }}
          </div>
          <div class="value" v-else>{{ bindInfo[item.value] || '--' }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="doctorHeader">
        <auth-img class="avator" :src="head_a" />
        <div class="intro">
          <div class="name">{{ bindInfo.userName }}</div>
          <div>ERP:{{ bindInfo.erpId }}</div>
          <div>使用权限：{{ ['正常', '停用', '注销', '停用 | 注销'][bindInfo.accountStatus] }}</div>
        </div>
      </div>
      <a-divider style="margin: 16px 0" />
      <div class="doctorInfo">
        <div v-for="item in assistantConfig" :key="item.label" class="infoItem">
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ bindInfo[item.value] || '--' }}</div>
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { getDoctorDetailById, getAssDetailById } from '@/api/workPlace/workOrder'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png' // BD的默认头像

const open = ref(false)
const title = ref('')
const bindType = ref('')
const bindInfo = ref({})

const initModal = (id, type) => {
  bindType.value = type
  bindInfo.value = {}
  let fetchApi = ''
  let params = {}
  if (type === 'doctor') {
    title.value = '医生'
    fetchApi = getDoctorDetailById
    params = { doctorId: id }
  } else {
    title.value = '专属医助'
    fetchApi = getAssDetailById
    params = { ucUserId: id }
  }
  open.value = true
  fetchApi(params).then(res => {
    bindInfo.value = type === 'doctor' ? (res && res.length ? res[0] : {}) : res
  })
}

const doctorConfig = [
  {
    label: '所属医院',
    value: 'hospital'
  },
  {
    label: '岗位职级',
    value: 'title'
  },
  {
    label: '个人简介',
    value: 'introduction'
  },
  {
    label: '个人公告',
    value: 'notice'
  }
]
const assistantConfig = [
  {
    label: '所属部门',
    value: 'deptName'
  }
]

defineExpose({
  initModal
})
</script>
<style lang="scss" scoped>
.doctorHeader {
  display: flex;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  .avator {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .name {
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    margin-bottom: 4px;
  }
}

.doctorInfo {
  .infoItem {
    display: flex;
    margin-bottom: 12px;
  }
  .label {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-right: 15px;
    min-width: 66px;
    flex-shrink: 0;
  }

  .value {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}
</style>
